import React from 'react';
import styled from 'styled-components';
import { ChartsOverview, HowItWorks, Overview, VaultInfo } from '.';
import { Tabs } from '../../../components/Tabs';
import { Subtitle2 } from '../../../components/Typography';
import { useMatchBreakpoints } from '../../../contexts';
import { StyledInfoDetail } from '../CardInfo/SharedComponents';
import { StrategyDropdownProps } from './types';

const Performance = (props: any) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.33333 15.5833C7.59306 15.5833 7.81092 15.4953 7.98692 15.3193C8.16231 15.1439 8.25 14.9264 8.25 14.6667V10.0833C8.25 9.82361 8.16231 9.60575 7.98692 9.42975C7.81092 9.25436 7.59306 9.16667 7.33333 9.16667C7.07361 9.16667 6.85575 9.25436 6.67975 9.42975C6.50436 9.60575 6.41667 9.82361 6.41667 10.0833V14.6667C6.41667 14.9264 6.50436 15.1439 6.67975 15.3193C6.85575 15.4953 7.07361 15.5833 7.33333 15.5833ZM11 15.5833C11.2597 15.5833 11.4776 15.4953 11.6536 15.3193C11.829 15.1439 11.9167 14.9264 11.9167 14.6667V7.33333C11.9167 7.07361 11.829 6.85575 11.6536 6.67975C11.4776 6.50436 11.2597 6.41667 11 6.41667C10.7403 6.41667 10.5227 6.50436 10.3473 6.67975C10.1713 6.85575 10.0833 7.07361 10.0833 7.33333V14.6667C10.0833 14.9264 10.1713 15.1439 10.3473 15.3193C10.5227 15.4953 10.7403 15.5833 11 15.5833ZM14.6667 15.5833C14.9264 15.5833 15.1439 15.4953 15.3193 15.3193C15.4953 15.1439 15.5833 14.9264 15.5833 14.6667V12.8333C15.5833 12.5736 15.4953 12.3557 15.3193 12.1797C15.1439 12.0044 14.9264 11.9167 14.6667 11.9167C14.4069 11.9167 14.1894 12.0044 14.014 12.1797C13.838 12.3557 13.75 12.5736 13.75 12.8333V14.6667C13.75 14.9264 13.838 15.1439 14.014 15.3193C14.1894 15.4953 14.4069 15.5833 14.6667 15.5833ZM4.58333 19.25C4.07917 19.25 3.64742 19.0706 3.28808 18.7119C2.92936 18.3526 2.75 17.9208 2.75 17.4167V4.58333C2.75 4.07917 2.92936 3.64742 3.28808 3.28808C3.64742 2.92936 4.07917 2.75 4.58333 2.75H17.4167C17.9208 2.75 18.3526 2.92936 18.7119 3.28808C19.0706 3.64742 19.25 4.07917 19.25 4.58333V17.4167C19.25 17.9208 19.0706 18.3526 18.7119 18.7119C18.3526 19.0706 17.9208 19.25 17.4167 19.25H4.58333ZM4.58333 17.4167H17.4167V4.58333H4.58333V17.4167ZM4.58333 17.4167V4.58333V17.4167Z"
      fill="white"
    />
  </svg>
);

const Vault = (props: any) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 14.5835C10.2598 14.5835 10.4776 14.4955 10.6536 14.3195C10.829 14.1441 10.9167 13.9266 10.9167 13.6668V9.97725C10.9167 9.71752 10.829 9.50363 10.6536 9.33558C10.4776 9.16752 10.2598 9.0835 10 9.0835C9.74032 9.0835 9.52276 9.17119 9.34737 9.34658C9.17137 9.52258 9.08337 9.74044 9.08337 10.0002V13.6897C9.08337 13.9495 9.17137 14.1634 9.34737 14.3314C9.52276 14.4995 9.74032 14.5835 10 14.5835ZM10 7.25016C10.2598 7.25016 10.4776 7.16216 10.6536 6.98616C10.829 6.81077 10.9167 6.59322 10.9167 6.3335C10.9167 6.07377 10.829 5.85591 10.6536 5.67991C10.4776 5.50452 10.2598 5.41683 10 5.41683C9.74032 5.41683 9.52276 5.50452 9.34737 5.67991C9.17137 5.85591 9.08337 6.07377 9.08337 6.3335C9.08337 6.59322 9.17137 6.81077 9.34737 6.98616C9.52276 7.16216 9.74032 7.25016 10 7.25016ZM10 19.1668C8.73199 19.1668 7.54032 18.9261 6.42504 18.4445C5.30976 17.9636 4.33962 17.3106 3.51462 16.4856C2.68962 15.6606 2.03665 14.6904 1.55571 13.5752C1.07415 12.4599 0.833374 11.2682 0.833374 10.0002C0.833374 8.73211 1.07415 7.54044 1.55571 6.42516C2.03665 5.30989 2.68962 4.33975 3.51462 3.51475C4.33962 2.68975 5.30976 2.03647 6.42504 1.55491C7.54032 1.07397 8.73199 0.833496 10 0.833496C11.2681 0.833496 12.4598 1.07397 13.575 1.55491C14.6903 2.03647 15.6605 2.68975 16.4855 3.51475C17.3105 4.33975 17.9634 5.30989 18.4444 6.42516C18.9259 7.54044 19.1667 8.73211 19.1667 10.0002C19.1667 11.2682 18.9259 12.4599 18.4444 13.5752C17.9634 14.6904 17.3105 15.6606 16.4855 16.4856C15.6605 17.3106 14.6903 17.9636 13.575 18.4445C12.4598 18.9261 11.2681 19.1668 10 19.1668ZM10 17.3335C12.032 17.3335 13.7623 16.6194 15.1911 15.1912C16.6193 13.7625 17.3334 12.0321 17.3334 10.0002C17.3334 7.96822 16.6193 6.23786 15.1911 4.80908C13.7623 3.38091 12.032 2.66683 10 2.66683C7.9681 2.66683 6.23804 3.38091 4.80987 4.80908C3.3811 6.23786 2.66671 7.96822 2.66671 10.0002C2.66671 12.0321 3.3811 13.7625 4.80987 15.1912C6.23804 16.6194 7.9681 17.3335 10 17.3335Z"
      fill="white"
    />
  </svg>
);

const Money = (props: any) => (
  <svg
    width="17"
    height="19"
    viewBox="0 0 17 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.5 0.75C10.6212 0.75 12.5847 1.124 14.0532 1.76658C14.7856 2.08742 15.4364 2.49258 15.9158 2.98942C16.3604 3.44775 16.6904 4.02342 16.7427 4.69075L16.75 4.875V14.0417C16.75 14.7878 16.4008 15.4258 15.9158 15.9272C15.4364 16.4241 14.7856 16.8293 14.0532 17.1501C12.5847 17.7917 10.6212 18.1667 8.5 18.1667C6.37883 18.1667 4.41533 17.7927 2.94683 17.1501C2.21442 16.8293 1.56358 16.4241 1.08417 15.9272C0.639583 15.4689 0.309583 14.8932 0.257333 14.2259L0.25 14.0417V4.875C0.25 4.12883 0.59925 3.49083 1.08417 2.98942C1.56358 2.49258 2.21442 2.08742 2.94683 1.76658C4.41533 1.12492 6.37883 0.75 8.5 0.75ZM14.9167 12.1231C14.6388 12.2896 14.3503 12.4378 14.0532 12.5667C12.5847 13.2084 10.6212 13.5833 8.5 13.5833C6.37883 13.5833 4.41533 13.2093 2.94683 12.5667C2.64965 12.4378 2.36121 12.2896 2.08333 12.1231V14.0417C2.08333 14.181 2.14383 14.3863 2.40233 14.6531C2.6645 14.9244 3.088 15.2104 3.682 15.4707C4.86817 15.9896 6.57042 16.3333 8.5 16.3333C10.4296 16.3333 12.1318 15.9896 13.318 15.4707C13.912 15.2104 14.3355 14.9244 14.5977 14.6531C14.8562 14.3872 14.9167 14.181 14.9167 14.0417V12.1231ZM14.9167 7.53975C14.6388 7.70625 14.3503 7.85445 14.0532 7.98342C12.5847 8.62508 10.6212 9 8.5 9C6.37883 9 4.41533 8.626 2.94683 7.98342C2.64965 7.85447 2.36121 7.70627 2.08333 7.53975V9.45833C2.08333 9.59767 2.14383 9.803 2.40233 10.0697C2.6645 10.3411 3.088 10.6271 3.682 10.8874C4.86817 11.4062 6.57042 11.75 8.5 11.75C10.4296 11.75 12.1318 11.4062 13.318 10.8874C13.912 10.6271 14.3355 10.3411 14.5977 10.0697C14.8562 9.80392 14.9167 9.59767 14.9167 9.45833V7.53975ZM8.5 2.58333C6.57042 2.58333 4.86817 2.92708 3.682 3.44592C3.088 3.70625 2.6645 3.99225 2.40233 4.26358C2.14383 4.52942 2.08333 4.73567 2.08333 4.875C2.08333 5.01433 2.14383 5.21967 2.40233 5.48642C2.6645 5.75775 3.088 6.04375 3.682 6.30408C4.86817 6.82292 6.57042 7.16667 8.5 7.16667C10.4296 7.16667 12.1318 6.82292 13.318 6.30408C13.912 6.04375 14.3355 5.75775 14.5977 5.48642C14.8562 5.22058 14.9167 5.01433 14.9167 4.875C14.9167 4.73567 14.8562 4.53033 14.5977 4.26358C14.3355 3.99225 13.912 3.70625 13.318 3.44592C12.1318 2.92708 10.4296 2.58333 8.5 2.58333Z"
      fill="white"
    />
  </svg>
);

const Flex = styled(Subtitle2)`
  display: flex;
  align-items: center;
  color: inherit;
  svg {
    margin-right: 6.75px;
  }
`;

export const StrategyDropdown: React.FC<StrategyDropdownProps> = ({
  tokens,
  charts,
  strategy,
  vaultItem,
  openStrategyDetails,
  MobileButtonGroup,
}) => {
  const { isSm } = useMatchBreakpoints();

  return (
    <div>
      <Tabs
        tabs={[
          {
            title: (
              <Flex>
                {!isSm ? (
                  <>
                    <Performance /> Performance Chart
                  </>
                ) : (
                  <>Overview</>
                )}
              </Flex>
            ),
            content: isSm ? (
              <>
                <Overview vaultItem={vaultItem} {...strategy} />
                <VaultInfo
                  strategy={strategy}
                  viewDetails={openStrategyDetails}
                />
                <StyledInfoDetail>{MobileButtonGroup}</StyledInfoDetail>
              </>
            ) : (
              <ChartsOverview
                charts={charts}
                tokens={tokens}
                openStrategyDetails={openStrategyDetails}
              />
            ),
          },
          {
            title: (
              <Flex>
                {!isSm ? (
                  <>
                    <Vault /> Vault Info
                  </>
                ) : (
                  <>Charts</>
                )}
              </Flex>
            ),
            content: !isSm ? (
              <VaultInfo
                strategy={strategy}
                viewDetails={openStrategyDetails}
              />
            ) : (
              <>
                <ChartsOverview charts={charts} tokens={tokens} />
                <StyledInfoDetail>{MobileButtonGroup}</StyledInfoDetail>
              </>
            ),
          },
          {
            title: (
              <Flex>
                {!isSm && <Money />}
                How It Works
              </Flex>
            ),
            content: (
              <>
                <HowItWorks
                  leverage={strategy.leverage}
                  tokenA={tokens[0]}
                  tokenB={tokens[1]}
                  vaultItem={vaultItem}
                />
                {isSm && (
                  <StyledInfoDetail>{MobileButtonGroup}</StyledInfoDetail>
                )}
              </>
            ),
          },
        ]}
        openDetails={openStrategyDetails}
      />
    </div>
  );
};
